import { IonCard, IonCardContent } from '@ionic/react';
import { Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { setCasinoGame } from '../../../store';
import { RootState } from '../../../models/RootState';
import './CasinoGamesMenu.scss';
import { CasinoGameDTO } from '../../../models/IndianCasinoState';

type SelectedCasinoGame = {
  id: string;
  name: string;
};
type StoreProps = {
  casinoGames: CasinoGameDTO[];
  setCasinoGame: (SelectedCasinoGame) => void;
};

const CasinoGamesMenu: React.FC<StoreProps> = (props) => {
  const { casinoGames, setCasinoGame } = props;
  const [tabValue, setTabValue] = useState<number>(0);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <div className="incasino-games-menu">
      <IonCard className="incasino-games-menu-card">
        <IonCardContent className="incasino-games-menu-card-content">
          <NavLink
            className="incasino-games-menu-nav-link notactive"
            to="/casino"
          >
            <Tab className="incasino-games-menu-tab" label="Indian Casino" />
          </NavLink>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={tabValue}
            onChange={handleTabChange}
            aria-label="Indian Casino Games Menu"
            className="incasino-games-menu-tabs"
            scrollButtons="off"
          >
            {casinoGames.map((ic, index) => (
              <NavLink
                className="incasino-games-menu-nav-link"
                to={`/casino/indian/${ic.id}`}
                onClick={() =>
                  setCasinoGame({
                    id: ic.id,
                    name: ic.name,
                  })
                }
              >
                <Tab className="incasino-games-menu-tab" label={ic.name} />
              </NavLink>
            ))}
          </Tabs>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    casinoGames: state.indianCasino.casinoGames,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setCasinoGame: (cGame: SelectedCasinoGame) =>
      dispatch(setCasinoGame(cGame)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CasinoGamesMenu);
